





























import Vue from 'vue'

export default Vue.extend({
  name: 'EmailClientFigure',

  props: {
    fromName: {
      type: String,
      default: '',
    },
    fromMail: {
      type: String,
      default: '',
    },
    showEditButton: {
      type: Boolean,
      default: true,
    },
  },
})
